<template>
<div style="min-height:100vh">
    <Sidebar v-if="appart"/>
    <Sidebar v-else title="Logis du Chateau" link="https://www.airbnb.fr/rooms/36438518" appartement="/logisduchateau"/>
    <div class="container-restaurant">
        <ul ref="list1">
           
        </ul>

    </div>
</div>
    
</template>


<script>
import Vue from 'vue'
import CardRestaurant from '../components/CardRestaurant'
import Sidebar from '../components/Sidebar'
export default {
    name : 'Restaurants',
    components : {
        Sidebar
    },
    beforeCreate: function() {
        document.body.className = 'musee';
    },computed: {

        appart() {
            if(this.$route.params.appartement == "chateau") return false;
            return true
        },
        

    },
    
    created()
    {
        const store = this.$firestore;
        store.collection('restaurants').get().then((querySnapshot) =>
        {
            querySnapshot.forEach((doc) => {

               var ItemClass = Vue.extend(CardRestaurant);
               var instance = new ItemClass({
                   propsData : {
                       title: doc.data().title,
                       cuisine: doc.data().cuisine,
                       img : doc.data().url_img,
                       web : doc.data().web,
                       tel : doc.data().tel,
                       adresse : doc.data().adresse,
                       score : parseInt(doc.data().score),
                       
                   }
               });
               instance.$mount();
               
               this.$refs.list1.appendChild(instance.$el)
            })
            
        })
    }    
}
</script>


<style scoped>

ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
}

.container-restaurant {
    padding: 1rem;
}

</style>